import { useState, useEffect } from 'react';
import api from '../../services/api';import "../../assets/styles/Intern/HelpDeskSection.css";

function HelpDeskSection() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    api.getTickets().then((d) => {setTickets(d || []);setLoading(false);}).catch(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    try {
      const res = await api.createTicket({ category: fd.get('category'), subject: fd.get('subject'), description: fd.get('description'), priority: fd.get('priority') });
      setTickets((prev) => [{ ticket_id: res.ticketId, subject: fd.get('subject'), category: fd.get('category'), priority: fd.get('priority'), status: 'open', created_at: new Date().toISOString() }, ...prev]);
      setShowForm(false);
      e.target.reset();
    } catch (err) {alert('Error: ' + err.message);}
  };

  const statusColor = (s) => ({ open: '#3b82f6', in_progress: '#d97706', resolved: '#2563eb', closed: '#94a3b8' })[s] || '#94a3b8';

  return (
    <div>
      <div className="helpdesksection-inline-1">
        <div className="helpdesksection-inline-2">{tickets.length} ticket{tickets.length !== 1 ? 's' : ''}</div>
        <button className="btn btn-sm helpdesksection-inline-3" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ New Ticket'}
        </button>
      </div>

      {showForm &&
      <div className="card helpdesksection-inline-4">
          <form onSubmit={handleSubmit}>
            <div className="helpdesksection-inline-5"><label className="helpdesksection-inline-6">Category</label>
              <select name="category" required className="helpdesksection-inline-7">
                <option value="IT Admin">IT Admin</option><option value="HR">HR</option><option value="Manager">Manager</option>
              </select></div>
            <div className="helpdesksection-inline-8"><label className="helpdesksection-inline-9">Subject</label>
              <input name="subject" placeholder="Brief description..." required className="helpdesksection-inline-10" /></div>
            <div className="helpdesksection-inline-11"><label className="helpdesksection-inline-12">Description</label>
              <textarea name="description" rows={3} placeholder="Details..." className="helpdesksection-inline-13" /></div>
            <div className="helpdesksection-inline-14"><label className="helpdesksection-inline-15">Priority</label>
              <select name="priority" className="helpdesksection-inline-16">
                <option value="Low">Low</option><option value="Medium" selected>Medium</option><option value="High">High</option>
              </select></div>
            <button type="submit" className="btn btn-sm helpdesksection-inline-17">Submit Ticket</button>
          </form>
        </div>
      }

      {loading ? <div className="helpdesksection-inline-18">Loading...</div> :
      tickets.length === 0 ? <div className="card helpdesksection-inline-19">No tickets yet</div> :
      tickets.map((t) =>
      <div key={t.ticket_id || t.id} className="card helpdesksection-inline-20">
          <div className="helpdesksection-inline-21">
            <div>
              <div className="helpdesksection-inline-22">{t.subject}</div>
              <div className="helpdesksection-inline-23">{t.category} · {t.priority || 'Medium'}</div>
              {t.description && <div className="helpdesksection-inline-24">{t.description}</div>}
              {t.hr_reply &&
            <div className="helpdesksection-inline-25">
                  <b className="helpdesksection-inline-26">HR Reply:</b> {t.hr_reply}
                </div>
            }
            </div>
            <div className="helpdesksection-inline-27">
              <span style={{ "--helpdesksection-1-color": statusColor(t.status), "--helpdesksection-1-background": statusColor(t.status) + '18' }} className="helpdesksection-dyn-1">{t.status}</span>
              <div className="helpdesksection-inline-28">{t.created_at ? new Date(t.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : ''}</div>
            </div>
          </div>
        </div>
      )}
    </div>);

}

export default HelpDeskSection;